import { Reducer } from "redux";

import { InformationReceivedResponse } from "../models/api/Patient";
import {
  InformationActionDispatchTypes,
  InformationResponseDefaultValues,
} from "../constants/Patient";
import { InformationDispatchTypes } from "../models/dispatchTypes/Patient";

const initialState: InformationReceivedResponse = {
  loading: false,
  response: InformationResponseDefaultValues,
  error: null,
};

const PostInformationReducer: Reducer<
  InformationReceivedResponse,
  InformationDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case InformationActionDispatchTypes.INFORMATION_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case InformationActionDispatchTypes.INFORMATION_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case InformationActionDispatchTypes.INFORMATION_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case InformationActionDispatchTypes.INFORMATION_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostInformationReducer;
